import React from 'react';
import { rankingsApi } from '~/routes/api'
import LayoutRanking from './components/Layout'

export default function RankingJersey() {
  return <LayoutRanking
    title="Ranking do IPG Jersey (Índice do Potencial Genético)"
    url={ rankingsApi.self.build({breed: 'JERSEY'}) }
  />
}